import React, { useState, useEffect } from 'react';
import { Button, Input, Select, Descriptions, Divider, Space, Row, Col, Tabs, Table, Card, Spin, Radio } from 'antd';
import FullHeightLayout from '../../components/FullHeightLayout';
import renderFileList from '../../components/renderFileList';

const { Option } = Select;

const InvoiceDetails = ({ detailData, lyData, webPost }) => {
    const [isloading, setIsloading] = useState(false);
    const [invoice_ly, setInvoice_ly] = useState(null);
    const [prepaymentDetails, setPrepaymentDetails] = useState(null);

    useEffect(() => {
        const getData = async () => {
            if (lyData) {
                setInvoice_ly(lyData);
            } else {
                if (!webPost) return;
                setIsloading(true);
                const fldata = await webPost('getInvoiceLy', { 'invoice_id': detailData.id });
                setInvoice_ly(fldata.ly);
                setIsloading(false);
            }
        }
        getData();
        return undefined;
    }, [lyData, detailData]);

    const getDetails = async (v) => {
        if (webPost && Number(v) === 2 && prepaymentDetails === null) {
            setIsloading(true);
            const res = await webPost("invoicezqdj", { invoice_id: detailData.id });
            if (res) {
                setPrepaymentDetails(res);
            }
            setIsloading(false);
        }
    }
    if(!detailData)return null;
    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={null}
        >
            <Tabs onChange={getDetails}>
                <Tabs.TabPane tab="销项票信息" key='1'>
                    <Spin spinning={isloading}>
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            业务明细
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 3 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="项目编号">{detailData.sn}</Descriptions.Item>
                            <Descriptions.Item label="项目名称">{detailData.xmmc}</Descriptions.Item>
                            <Descriptions.Item label="合同金额（人民币）">{detailData.ht_money}</Descriptions.Item>
                            <Descriptions.Item label="计税方法">{detailData.tax_type}</Descriptions.Item>
                            <Descriptions.Item label="累计已开票金额">{detailData.xxp_yk}</Descriptions.Item>
                            <Descriptions.Item label="未开票金额">{detailData.xxp_wk}</Descriptions.Item>
                            <Descriptions.Item label="是否异地预缴">{detailData.is_yd === '1' ? '是' : '否'}</Descriptions.Item>
                            <Descriptions.Item label="是否预收款">{detailData.is_ys === '1' ? '是' : '否'}</Descriptions.Item>
                            <Descriptions.Item label="含税金额">{detailData.amount}</Descriptions.Item>
                            <Descriptions.Item label="开票税率">{detailData.kpsl}%</Descriptions.Item>
                            <Descriptions.Item label="应收税款">{detailData.amount_sj}</Descriptions.Item>
                            <Descriptions.Item label="费用科目">{detailData.km}</Descriptions.Item>
                            <Descriptions.Item label="申请单号">{detailData.isn}</Descriptions.Item>
                            <Descriptions.Item label="制单日期">{detailData.make_date}</Descriptions.Item>
                            <Descriptions.Item label="备注" span={3}>{detailData.ps}</Descriptions.Item>
                        </Descriptions>
                        {invoice_ly && invoice_ly.map((it) => {
                            return (
                                <Descriptions
                                    layout="vertical"
                                    column={{ xs: 2, sm: 4, md: 4 }}
                                    bordered
                                    size="middle"
                                    style={{ marginBottom: 24 }}
                                >
                                    <Descriptions.Item label="应收税金缴纳方式">{it.type}</Descriptions.Item>
                                    <Descriptions.Item label="来源对象">{it.cw_data_id === 0 ? (it.type === '资金垫付' ? '资金垫付' : '现付') : it.zfly}</Descriptions.Item>
                                    <Descriptions.Item label="支付金额">{it.amount}</Descriptions.Item>
                                    <Descriptions.Item label="付款账户">{it.bank_acc}</Descriptions.Item>
                                </Descriptions>
                            );
                        })}
                        {/* 发票销售方信息 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            发票销售方信息
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 3 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="单位名称">{detailData.xs_dw}</Descriptions.Item>
                            <Descriptions.Item label="税号">{detailData.xs_sh}</Descriptions.Item>
                            <Descriptions.Item label="开户银行">{detailData.xs_khh}</Descriptions.Item>
                            <Descriptions.Item label="银行账号">{detailData.xs_yhzh}</Descriptions.Item>
                            <Descriptions.Item label="单位地址">{detailData.xs_dwdz}</Descriptions.Item>
                            <Descriptions.Item label="电话">{detailData.xs_tel}</Descriptions.Item>
                            <Descriptions.Item label="是否展示银行账号">{Number(detailData.xs_zs_yhzh)=== 1 ? '是' : '否'}</Descriptions.Item>
                            <Descriptions.Item label="是否展示地址电话">{Number(detailData.xs_zs_dwdz) === 1 ? '是' : '否'}</Descriptions.Item>
                        </Descriptions>

                        {/* 发票购买方信息 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            发票购买方信息
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 3 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="单位名称">{detailData.mf_dw}</Descriptions.Item>
                            <Descriptions.Item label="税号">{detailData.mf_sh}</Descriptions.Item>
                            <Descriptions.Item label="开户银行">{detailData.mf_khh}</Descriptions.Item>
                            <Descriptions.Item label="银行账号">{detailData.mf_yhzh}</Descriptions.Item>
                            <Descriptions.Item label="单位地址">{detailData.mf_dwdz}</Descriptions.Item>
                            <Descriptions.Item label="电话">{detailData.mf_tel}</Descriptions.Item>
                            <Descriptions.Item label="是否展示银行账号">{Number(detailData.mf_zs_yhzh) === 1 ? '是' : '否'}</Descriptions.Item>
                            <Descriptions.Item label="是否展示地址电话">{Number(detailData.mf_zs_dwdz) === 1 ? '是' : '否'}</Descriptions.Item>
                        </Descriptions>

                        {/* 特定要素 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            特定要素
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 4 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="房地产开发">{detailData.is_fdc === '1' ? '是' : '否'}</Descriptions.Item>
                            <Descriptions.Item label="应税行为发生地">{detailData.ys_dz}</Descriptions.Item>
                            <Descriptions.Item label="土地增值税编号">{detailData.zzs_sn}</Descriptions.Item>
                            <Descriptions.Item label="跨地（市）标志">{detailData.mark_ds === '1' ? '是' : '否'}</Descriptions.Item>
                        </Descriptions>

                        {/* 明细 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            明细
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 4 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="商品">{detailData.spmc}</Descriptions.Item>
                            <Descriptions.Item label="税收分类简称">{detailData.shui_shou_jian_cheng}</Descriptions.Item>
                            <Descriptions.Item label="发票类型">{Number(detailData.fp_type) === 1 ? '电子专票' : '普票'}</Descriptions.Item>
                            <Descriptions.Item label="开票税率">{detailData.kp_slv}%</Descriptions.Item>

                            <Descriptions.Item label="商品数量">{detailData.sp_sl}</Descriptions.Item>
                            <Descriptions.Item label="单价">{detailData.sp_dj}</Descriptions.Item>
                            <Descriptions.Item label="不含税金额">{detailData.bhsje}</Descriptions.Item>

                            <Descriptions.Item label="税额">{detailData.se}</Descriptions.Item>
                            <Descriptions.Item label="含税金额">{detailData.amount}</Descriptions.Item>
                            <Descriptions.Item label="建筑项目名称">{detailData.jz_xm_mc}</Descriptions.Item>
                            <Descriptions.Item label="建筑服务发生地">{detailData.jz_fw_fd}</Descriptions.Item>

                            <Descriptions.Item label="备注" span={4}>{detailData.ps2}</Descriptions.Item>
                        </Descriptions>
                        {detailData.files1 &&
                            <Descriptions
                                layout="vertical"
                                column={{ xs: 1, sm: 1, md: 1 }}
                                bordered
                                size="middle"
                                style={{ marginBottom: 24 }}
                            >
                                <Descriptions.Item label="付款凭据">{renderFileList(detailData.files1)}</Descriptions.Item>
                            </Descriptions>
                        }
                    </Spin>
                </Tabs.TabPane>
                {detailData.status > 2 && <Tabs.TabPane tab="债权登记信息" key="2">
                    <Spin spinning={isloading}>
                        {/* 发票销售方信息 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            发票销售方信息
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 4 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="单位名称">{detailData.xs_dw}</Descriptions.Item>
                            <Descriptions.Item label="税号">{detailData.xs_sh}</Descriptions.Item>
                            <Descriptions.Item label="开户银行">{detailData.xs_khh}</Descriptions.Item>
                            <Descriptions.Item label="银行账号">{detailData.xs_yhzh}</Descriptions.Item>
                            <Descriptions.Item label="单位地址">{detailData.xs_dwdz}</Descriptions.Item>
                            <Descriptions.Item label="电话">{detailData.xs_tel}</Descriptions.Item>
                        </Descriptions>

                        {/* 发票购买方信息 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            发票购买方信息
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 4 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="单位名称">{detailData.mf_dw}</Descriptions.Item>
                            <Descriptions.Item label="税号">{detailData.mf_sh}</Descriptions.Item>
                            <Descriptions.Item label="纳税人类型">{detailData.mf_nsr}</Descriptions.Item>
                            <Descriptions.Item label="开户银行">{detailData.mf_khh}</Descriptions.Item>
                            <Descriptions.Item label="银行账号">{detailData.mf_yhzh}</Descriptions.Item>
                            <Descriptions.Item label="单位地址">{detailData.mf_dwdz}</Descriptions.Item>
                            <Descriptions.Item label="电话">{detailData.mf_tel}</Descriptions.Item>
                        </Descriptions>

                        {/* 业务明细 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            业务明细
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 1, sm: 2, md: 4 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="开票申请单号">{detailData.isn}</Descriptions.Item>
                            <Descriptions.Item label="开票日期">{detailData.make_date2}</Descriptions.Item>
                            <Descriptions.Item label="发票号码">{detailData.invoice_no}</Descriptions.Item>
                            <Descriptions.Item label="发票类型">
                                {Number(detailData.fp_type) === 1 ? '电子专票' : '普票'}
                            </Descriptions.Item>
                            <Descriptions.Item label="商品">{detailData.spmc}</Descriptions.Item>
                            <Descriptions.Item label="商品数量">{detailData.sp_sl}</Descriptions.Item>
                            <Descriptions.Item label="单价">{detailData.sp_dj}</Descriptions.Item>
                            <Descriptions.Item label="开票税率">{detailData.kpsl}%</Descriptions.Item>
                            <Descriptions.Item label="不含税金额">{detailData.bhsje}</Descriptions.Item>
                            <Descriptions.Item label="税额">{detailData.se}</Descriptions.Item>
                            <Descriptions.Item label="含税金额">{detailData.amount}</Descriptions.Item>
                            <Descriptions.Item label="项目编号">{detailData.sn}</Descriptions.Item>
                            <Descriptions.Item label="建筑项目名称">{detailData.jz_xm_mc}</Descriptions.Item>
                            <Descriptions.Item label="建筑服务发生地">{detailData.jz_fw_fd}</Descriptions.Item>
                        </Descriptions>

                        {/* 预缴情况 */}
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            预缴情况
                        </Divider>
                        <Descriptions>
                            <Descriptions.Item label="外经证编号">{detailData.wjz_no}</Descriptions.Item>
                            <Descriptions.Item label="发票号码">{detailData.invoice_no}</Descriptions.Item>
                            <Descriptions.Item label="应收税款">{detailData.amount_sj}</Descriptions.Item>
                        </Descriptions>

                        {/* 这里假设您有一个预缴明细的数组来渲染表格 */}
                        <Table
                            dataSource={prepaymentDetails || []}
                            pagination={false}
                            bordered
                            size="middle"
                        >
                            <Table.Column title="外经证编号" dataIndex="wjz_no" />
                            <Table.Column title="税种类型" dataIndex="szlx" />
                            <Table.Column title="计税金额" dataIndex="js_amt" />
                            <Table.Column title="税率（%）" dataIndex="js_sl" />
                            <Table.Column title="税额" dataIndex="js_se" />
                        </Table>

                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            外经证/反馈表
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 2, sm: 2, md: 2 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="外经证">{renderFileList(detailData.files2)}</Descriptions.Item>
                            <Descriptions.Item label="反馈表">{renderFileList(detailData.files3)}</Descriptions.Item>
                        </Descriptions>
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            完税证明
                        </Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 2, sm: 2, md: 2 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="预缴增值税">{renderFileList(detailData.files4)}</Descriptions.Item>
                            <Descriptions.Item label="预缴企业所得税">{renderFileList(detailData.files5)}</Descriptions.Item>
                            <Descriptions.Item label="其它税额">{renderFileList(detailData.files6)}</Descriptions.Item>
                            <Descriptions.Item label="个人所得税">{renderFileList(detailData.files7)}</Descriptions.Item>
                        </Descriptions>
                        <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>发票</Divider>
                        <Descriptions
                            layout="vertical"
                            column={{ xs: 2, sm: 2, md: 2 }}
                            bordered
                            size="middle"
                            style={{ marginBottom: 24 }}
                        >
                            <Descriptions.Item label="发票">{renderFileList(detailData.files8)}</Descriptions.Item>
                        </Descriptions>
                    </Spin>
                </Tabs.TabPane>}
            </Tabs>

        </FullHeightLayout >
    );
};

export default InvoiceDetails;